import axios from "axios";
import axiosRetry from "axios-retry";
import toastr from "toastr";
import * as actions from "./actionsTypes";
import errorManage from "../../errorManage";

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getSurveys = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SURVEYS,
      payload: true,
    });

    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    const resp = await client.get(`/api/app/Clima_Encuesta_CheckList/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      params: data,
    });

    dispatch({
      type: actions.GET_SURVEYS,
      payload: {
        surveyList: resp.data.data,
        surveyLength: resp.data.count,
      },
    });
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        // errorManage(ex);
      }
    } else {
      // errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_SURVEYS,
      payload: false,
    });
  }
};

export const getSurvey =
  (id, userId, userType, history) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_SURVEY,
        payload: true,
      });

      const { token } =
        getState().auth || localStorage.getItem("auth")
          ? JSON.parse(localStorage.getItem("auth"))
          : { token: "" };
      await client.post(
        `/api/app/validacion_mi_encuesta/`,
        { encuesta_id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );
      const resp = await client.get(`/api/app/Clima_Encuesta/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      });
      dispatch({
        type: actions.GET_SURVEY,
        payload: {
          survey: resp.data,
        },
      });
    } catch (ex) {
      if (ex.response) {
        if (ex.response.status === 400) {
          if (Array.isArray(ex.response.data)) {
            ex.response.data.forEach((item) => {
              toastr.error(item);
            });
          } else {
            toastr.error(ex.response.data);
          }
        } else if (ex.response.status === 404) {
          toastr.info("La encuesta no esta disponible");
          history.push(`/detalle-empleado/${userId}/${userType}`);
        } else {
          errorManage(ex);
        }
      } else {
        errorManage(ex);
      }
    } finally {
      dispatch({
        type: actions.LOADING_SURVEY,
        payload: false,
      });
    }
  };

export const saveSurvey = (data, dataPut, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SURVEY,
      payload: true,
    });
    // console.log(data)
    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    await client.post(`/api/app/Clima_Respuestas/`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    await client.put(`/api/app/Clima_Encuesta/${id}/`, dataPut, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    // toastr.success(messages.successMessage);
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.SAVE_LOADER_SURVEY,
      payload: false,
    });
  }
};

export const editEncuesta = (dataPut, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SURVEY,
      payload: true,
    });
    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    await client.put(`/api/app/Clima_Encuesta/${id}/`, dataPut, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    // toastr.success(messages.successMessage);
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_SURVEY,
      payload: false,
    });
  }
};

export const editSurvey = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SURVEY,
      payload: true,
    });

    const { token } =
      getState().auth || localStorage.getItem("auth")
        ? JSON.parse(localStorage.getItem("auth"))
        : { token: "" };
    await client.put(`/api/app/Clima_Encuesta/${id}/`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    // toastr.success(messages.successMessage);
  } catch (ex) {
    if (ex.response) {
      if (ex.response.status === 400) {
        if (Array.isArray(ex.response.data)) {
          ex.response.data.forEach((item) => {
            toastr.error(item);
          });
        } else {
          toastr.error(ex.response.data);
        }
      } else {
        errorManage(ex);
      }
    } else {
      errorManage(ex);
    }
  } finally {
    dispatch({
      type: actions.LOADING_SURVEY,
      payload: false,
    });
  }
};
